"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.hoverStyles = exports.default = exports.TextWrapper = exports.StyledButton = exports.GRButtonStyles = exports.ButtonStyles = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _breakpoints = _interopRequireDefault(require("../breakpoints"));
var _LexusTypography = require("../LexusTypography");
var _ToyotaTypography = require("../ToyotaTypography");
const TextWrapper = exports.TextWrapper = _styledComponents.default.span`
`;
const GRButtonStyles = exports.GRButtonStyles = (0, _styledComponents.css)`
  ${(0, _LexusTypography.akkuratMono)({
  sizing: "link13"
})}
  line-height: 24px;
  transform: skewX(-23deg);
  border-radius: 8px 0 12px 16px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 0 30px;
  & {
    ${(0, _breakpoints.default)("desktop", "up")}{
      padding: 0 50px;
    }
  }
  ${TextWrapper} {
    transform: skewX(23deg);
  }
`;
const PRIMARY_BLACK_STYLES = (0, _styledComponents.css)`
  color: #FFF;
  border-style: solid;
  border-width: 2px;
  border-color: #000000;
  background-color: #000000;
  &:disabled, &[aria-disabled="true"] {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
const PRIMARY_BLACK_HOVER_STYLES = (0, _styledComponents.css)`
  color: #000;
  border: 2px solid #000000;
  background-color: transparent;
`;
const styles = exports.styles = {
  default: PRIMARY_BLACK_STYLES,
  PrimaryBlack: PRIMARY_BLACK_STYLES,
  PrimaryWhite: (0, _styledComponents.css)`
    color: #000;
    border: 2px solid #FFF;
    background-color: #FFF;
    &:disabled, &[aria-disabled="true"] {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `,
  BespokeBlack: (0, _styledComponents.css)`
    color: #FFF;
    border: 2px solid #000;
    background-color: #000;
    &:disabled, &[aria-disabled="true"] {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `,
  BespokeWhite: (0, _styledComponents.css)`
    color: #000;
    border: 2px solid #FFF;
    background-color: #FFF;
    &:disabled, &[aria-disabled="true"] {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `,
  SecondaryBlack: (0, _styledComponents.css)`
    color: #000000;
    border: 2px solid #000000;
    background-color: transparent;
    &:disabled, &[aria-disabled="true"] {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `,
  SecondaryWhite: (0, _styledComponents.css)`
    color: #FFF;
    border: 2px solid #FFF;
    background-color: transparent;
    &:disabled, &[aria-disabled="true"] {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `,
  PrimaryGold: (0, _styledComponents.css)`
    color: #000;
    border: 2px solid #a48b5b;
    background-color: #a48b5b;
    &:disabled, &[aria-disabled="true"] {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `,
  SecondaryGold: (0, _styledComponents.css)`
    color: #000;
    border: 2px solid #a48b5b;
    background-color: transparent;
    &:disabled, &[aria-disabled="true"] {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `,
  ToyotaRed: (0, _styledComponents.css)`
    ${(0, _ToyotaTypography.ToyotaType)({
    sizing: "body02",
    weight: "semibold"
  })};
    color: #FFF;
    border: none;
    background-color: #e10a1d;
    &:disabled, &[aria-disabled="true"] {
      background-color: #666;
    }
  `,
  ToyotaBlack: (0, _styledComponents.css)`
    ${(0, _ToyotaTypography.ToyotaType)({
    sizing: "body02",
    weight: "semibold"
  })};
    color:#FFF;
    display: flex;
    padding: 13px 32px;
    justify-content: center;
    align-items: center;
    border-radius: 28px;
    background: #000;
    border: transparent;
    &:disabled, &[aria-disabled="true"] {
      color: #767676;
      border: none;
      background-color: #D8D8D8;
      cursor: not-allowed;
    }
  `,
  ToyotaWhite: (0, _styledComponents.css)`
    ${(0, _ToyotaTypography.ToyotaType)({
    sizing: "body02",
    weight: "semibold"
  })};
    background: #FFF;
    color:#000;
    display: flex;
    padding: 13px 32px;
    justify-content: center;
    align-items: center;
    border-radius: 50px;
    border: 1px solid #767676;
    &:disabled, &[aria-disabled="true"] {
      color: #767676;
      background-color: #D8D8D8;
      cursor: not-allowed;
      border: none !important;
    }
  `,
  SSBackBtn: (0, _styledComponents.css)`
    color: #000;
    border: none;
    background: #fff;
    border-radius: 28px;
    padding: 12px 32px;
    gap: 8px;
    ${(0, _ToyotaTypography.ToyotaType)({
    sizing: "body01",
    weight: "semibold"
  })};
  `,
  SSNextBtn: (0, _styledComponents.css)`
    color: #ffff;
    background: #000;
    border-radius: 28px;
    padding: 12px 32px;
    gap: 8px;
    &:disabled, &[aria-disabled="true"] {
      opacity: 0.5;
      cursor: not-allowed;
    }
    ${(0, _ToyotaTypography.ToyotaType)({
    sizing: "body01",
    weight: "semibold"
  })};
  `,
  SSRedBtn: (0, _styledComponents.css)`
  ${(0, _ToyotaTypography.ToyotaType)({
    sizing: "body02",
    weight: "semibold"
  })};
  background: #E10A1D;
  color:#FFF;
  display: flex;
  padding: 13px 32px;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  border: 1px solid #E10A1D;
  &:disabled, &[aria-disabled="true"] {
      color: #767676;
      background-color: #D8D8D8;
      cursor: not-allowed;
      border: none !important;
  }`,
  TimeButton: (0, _styledComponents.css)`
    ${(0, _ToyotaTypography.ToyotaType)({
    sizing: "body01",
    weight: "book"
  })};
    color: #000;
    border: ${function (_ref) {
    let {
      $selectedHour,
      $timeWithPeriod
    } = _ref;
    return $selectedHour === $timeWithPeriod ? "1px solid black" : "1px solid #F6F6F6";
  }};
    max-width: ${function (_ref2) {
    let {
      $size
    } = _ref2;
    return $size === 2 ? "156px" : "112px";
  }};
    padding: 0;
    gap: 24px;
    border-radius: 8px;
    background-color: #F6F6F6;
    flex: 1;

  `,
  LexusTimeButton: (0, _styledComponents.css)`
    ${(0, _LexusTypography.nobel)({
    sizing: "body12",
    weight: "book"
  })}
    color: #000;
    border: ${function (_ref3) {
    let {
      $selectedHour,
      $timeWithPeriod
    } = _ref3;
    return $selectedHour === $timeWithPeriod ? "2px solid #a48b5b" : "1px solid #999";
  }};
    max-width: ${function (_ref4) {
    let {
      $size
    } = _ref4;
    return $size === 2 ? "156px" : "112px";
  }};
    padding: 0;
    border-radius: 0;
    background-color: #FFF;
    flex: 1;
  `,
  ToyotaSSTTransparent: (0, _styledComponents.css)`
    ${(0, _ToyotaTypography.ToyotaType)({
    sizing: "body02",
    weight: "semibold"
  })};
    background: transparent;
    color:#000;
    display: flex;
    padding: 13px 32px;
    justify-content: center;
    align-items: center;
    border-radius: 50px;
    border: none;
    gap: 4px;
    &:disabled {
        color: #767676;
        background-color: transparent;
        cursor: not-allowed;
        border: none !important;
  }
  `,
  ToyotaSSTSetPreferredVehicle: (0, _styledComponents.css)`
    ${(0, _ToyotaTypography.ToyotaType)({
    sizing: "body02",
    weight: "semibold"
  })};
    display: flex;
    border-radius: 50px;
    justify-content: center;
    background-color: transparent;
    &:disabled {
     color: #D8D8D8;
    }
`,
  MyLexusTransparent: (0, _styledComponents.css)`
  ${(0, _LexusTypography.nobel)({
    sizing: "body12",
    weight: "bold"
  })}
  color: #000;
  min-width: 0 !important;
  padding: 0 !important;
  border: none;
  background: transparent;
  padding: 0;
  height: unset;
`,
  GRPrimaryRed: (0, _styledComponents.css)`
  color: #FFF;
  border-style: solid;
  border-width: 2px;
  border-color: #EB0008;
  background-color: #EB0008;
  ${GRButtonStyles}
  &:disabled, &[aria-disabled="true"] {
    color: #f5f5f5;
    background-color: #999;
    border-color: #999;
    cursor: not-allowed;
  }
`,
  GRSecondaryRed: (0, _styledComponents.css)`
  color: #FFF;
  border: 2px solid #EB0008;
  background-color: transparent;
  ${GRButtonStyles}
  &:disabled, &[aria-disabled="true"] {
    color: #999;
    border: 2px solid #616161;
    cursor: not-allowed;
  }
`,
  GRPrimaryBlack: (0, _styledComponents.css)`
  color: #FFF;
  border: 2px solid #000;
  background-color: #000;
  ${GRButtonStyles}
  &:disabled, &[aria-disabled="true"] {
    color: "#999";
    background-color: #000;
    cursor: not-allowed;
  }
  `,
  GRPrimaryWhite: (0, _styledComponents.css)`
  color: #000;
  border: 2px solid #fff;
  background-color: #fff;
  ${GRButtonStyles}
  &:disabled, &[aria-disabled="true"] {
    color: #616161;
    border-color: #fff;
    background-color: #fff;
    cursor: not-allowed;
  }`
};
const hoverStyles = exports.hoverStyles = {
  default: PRIMARY_BLACK_HOVER_STYLES,
  PrimaryBlack: PRIMARY_BLACK_HOVER_STYLES,
  PrimaryWhite: (0, _styledComponents.css)`
    color: #FFF;
    border: 2px solid #FFF;
    background-color: transparent;
  `,
  BespokeBlack: (0, _styledComponents.css)`
    color: #000;
    border: 2px solid #000;
    background-color: #FFF;
  `,
  BespokeWhite: (0, _styledComponents.css)`
    color: #FFF;
    border: 2px solid #FFF;
    background-color: #000;
  `,
  SecondaryBlack: (0, _styledComponents.css)`
    color: #fff;
    border-width: 2px;
    border-style: solid;
    border-color: #000000;
    background-color: #000000;
  `,
  SecondaryWhite: (0, _styledComponents.css)`
    color: #000;
    border: 2px solid #FFF;
    background-color: #FFF;
  `,
  PrimaryGold: (0, _styledComponents.css)`
    color: #000;
    border: 2px solid #a48b5b;
    background-color: transparent;
  `,
  SecondaryGold: (0, _styledComponents.css)`
    color: #000;
    border: 2px solid #a48b5b;
    background-color: #a48b5b;
  `,
  ToyotaRed: (0, _styledComponents.css)`
    color: #FFF;
    background-color: #900;
  `,
  ToyotaBlack: (0, _styledComponents.css)`
   &:not(:disabled) {
     color: #FFF;
     background: #000;
   }
`,
  ToyotaWhite: (0, _styledComponents.css)`
    color: #767676;
    background-color: #D8D8D8;
    &:not(:disabled) {
     color: #000;
     background: #FFF;
   }

  `,
  SSBackBtn: (0, _styledComponents.css)`
    color: #000;
    background-color: #FFF;
  `,
  SSNextBtn: (0, _styledComponents.css)`
    color: #FFF;
    background-color: #000;
  `,
  SSRedBtn: (0, _styledComponents.css)`
    color: #FFF;
    background: #E10A1D;
    `,
  TimeButton: (0, _styledComponents.css)`
    color: #000;
    background-color: #F6F6F6;
  `,
  ToyotaSSTTransparent: (0, _styledComponents.css)`
    color: #000;
    background-color: transparent;
  `,
  ToyotaSSTSetPreferredVehicle: (0, _styledComponents.css)`
   color: #D8D8D8;
    &:not(:disabled) {
      color: #000;
    }
  `,
  MyLexusTransparent: (0, _styledComponents.css)`
  color: #000;
  opacity: 0.5;
  background-color: transparent;
`,
  GRPrimaryRed: (0, _styledComponents.css)`
    color: #ffffff;
    border-style: solid;
    border-width: 2px;
    border-color: #e60010;
    background-color: transparent;
  `,
  GRSecondaryRed: (0, _styledComponents.css)`
    color: #ffffff;
    border: 2px solid #999;
    background-color: #000000;
  `,
  GRPrimaryBlack: (0, _styledComponents.css)`
    color: #000;
    border: 2px solid #000;
    background-color: #fff;
  `,
  GRPrimaryWhite: (0, _styledComponents.css)`
    color: #fff;
    border: 2px solid #fff;
    background-color: #000;
  `
};
const ButtonStyles = exports.ButtonStyles = (0, _styledComponents.css)`
  transition: all 150ms cubic-bezier(0.335, 0.015, 0.46, 0.995);
  box-sizing: border-box;
  text-decoration: none;
  text-align: center;
  cursor: pointer;

  padding: 0 20px;
  min-width: 150px;

  height: 50px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  ${function (props) {
  return styles[props.$variant] || styles.default;
}}
  ${function (_ref5) {
  let {
    $buttonSize
  } = _ref5;
  if ($buttonSize === "small") return `
      min-width: initial;
      height: 40px;
      padding: 0 16px;
    `;
  if ($buttonSize === "toyota") return `
      min-width: initial;
      padding: 13px 20px;
      height: initial;
    `;
  return "";
}}

  ${function (_ref6) {
  let {
    $active,
    $variant
  } = _ref6;
  return $active === true && (hoverStyles[$variant] || hoverStyles.default);
}}

  ${(0, _breakpoints.default)("desktop", "up")}{
    min-width: 220px;
    padding: 0 30px;
    ${function (_ref7) {
  let {
    $buttonSize
  } = _ref7;
  if ($buttonSize === "small") return `
        min-width: initial;
        padding: 0 16px;
      `;
  if ($buttonSize === "toyota") return `
        min-width: initial;
        padding: 16px 24px;
      `;
  return "";
}}

    &:not(:disabled):not([aria-disabled="true"]):hover {
      ${function (props) {
  return hoverStyles[props.$variant] || hoverStyles.default;
}}
    }
  }
`;
const StyledButton = function (component) {
  return (0, _styledComponents.default)(component)`${ButtonStyles}`;
};
exports.StyledButton = StyledButton;
var _default = exports.default = {
  TextWrapper,
  A: _styledComponents.default.a`
    font: var(--LexusButton-font, 13px/18px "nobel-bold");
    letter-spacing: var(--LexusButton-font, 0.04em);
    ${ButtonStyles}
  `,
  Button: _styledComponents.default.button`
    font: var(--LexusButton-font, 13px/18px "nobel-bold");
    letter-spacing: var(--LexusButton-font, 0.04em);
    ${ButtonStyles}
  `
};